import React from "react";
import Image from "next/image";
import InfoIcon from "@/v2-components/core/icon/info-icon";
import { useTrans } from "@/utils/useTrans";
import InnerHtml from "@/common/InnerHtml";

const TactVisorInstallation = () => {
  const { t } = useTrans(["tactsuit"]);
  const steps = [
    {
      number: 1,
      instruction: t("Remove the facial interface inside the HMD unit."),
      image: "/images/tactsuit/tactvisor/install1.png",
    },
    {
      number: 2,
      instruction: t(
        "Remove the cushion from the facial interface with velcro attachment*.",
      ),
      image: "/images/tactsuit/tactvisor/install2.png",
    },
    {
      number: 3,
      instruction: t(
        "Install the facial interface with velcro attachment* to your HMD.",
      ),
      image: "/images/tactsuit/tactvisor/install3.png",
    },
    {
      number: 4,
      instruction: t("Attach the TactVisor to the velcro area."),
      image: "/images/tactsuit/tactvisor/install4.png",
    },
    {
      number: 5,
      instruction: t(
        "Attach the main controller to the top of the HMD with the included velcro stickers.",
      ),
      image: "/images/tactsuit/tactvisor/install5.png",
      width: 294,
    },
  ];
  return (
    <div className="max-w-screen-max">
      <div className="flex flex-col items-center justify-center">
        <h1 className="w-full text-center text-2xl laptop:py-6 laptop:text-start">
          {t("Installing TactVisor on your HMD")}
        </h1>
        <div className="mt-5 grid max-w-[1190px] grid-cols-2 justify-between gap-8 laptop:flex">
          {steps.map((step) => (
            <div key={step.number} className="flex flex-col last:col-span-2">
              <div className={"flex h-[140px] w-full"}>
                <Image
                  src={step.image}
                  alt={`Step ${step.number}`}
                  height={140}
                  width={step.width ?? 190}
                  className="mb-2 object-contain"
                />
              </div>
              <p className="mb-1 font-600">
                {t("Step")} {step.number}
              </p>
              <p className={`text-sm`}>{step.instruction}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-10 flex flex-col items-center text-sm text-coolgray-90">
        <div className="whitespace-pre-line text-center laptop:whitespace-normal">
          <InnerHtml
            html={t(
              `<p><a href="https://www.vrcover.com">* VR Cover</a> and <a href="https://www.kiwidesign.com">KIWI design</a> and others</p>`,
            )}
          />
        </div>
        <div className="mt-4 flex flex-col items-center gap-1 text-coolgray-50 laptop:mt-2 laptop:flex-row laptop:items-start">
          <InfoIcon className="size-5" />
          <div className="whitespace-pre-line text-center laptop:pt-0.5">
            <p>
              {t(
                `Facial Interface with velcro attachment* is required for Valve Index, Meta Quest1, 2, 3, 3S and Rift S.`,
              )}
            </p>
            <a
              href="https://www.youtube.com/bhaptics"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-1 hover:underline"
            >
              {t("Guide video is available at www.youtube.com/bhaptics")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TactVisorInstallation;
